import { inject, injectable } from 'inversify';
import { organisation_change_full } from '@Api';
import { OrganisationChange } from '@Models';
import { TYPES } from '@Types';
import { OrganisationChangeAvailabilityMapper } from './OrganisationChangeAvailabilityMapper';

@injectable()
export class OrganisationChangeMapper {
  @inject(TYPES.Mapper.OrganisationChangeAvailabilityMapper)
  private _organisationChangeAvailabilityMapper!: OrganisationChangeAvailabilityMapper;

  public map(item: organisation_change_full): OrganisationChange {
    return {
      default_organisation_id: item.default_organisation_id,
      new_organisation_id: item.new_organisation_id,
      addOrganisationId: item.add_organisation_id,
      isMin: item.isMin,
      isMax: item.isMax,
      number: item.number,
      max: item.max,
      availabilities: item.availabilities.map((a) =>
        this._organisationChangeAvailabilityMapper.map(a),
      ),
    } satisfies OrganisationChange as OrganisationChange;
  }
}
